import { EMPTY_OBJECT } from '~/src/Lib/Utils'

export const MENTION_PATTERNS = {
  MATCH: /@\[(.*)\]\(\d+\)$/g,
  REPLACE: /\[|\]\(\d+\)$/g,
  MATCH_IN: /@\[(.*)\]\(\d+\)/g,
}

export const parseMentions = text => {
  const output = []
  let index = 0
  while (text.slice(index).match(MENTION_PATTERNS.MATCH_IN)) {
    const str = text.slice(index)
    const start = str.indexOf('@[')
    const {
      0: middleMatch,
      index: middleStart = NaN,
      // deepcode ignore ArithmeticOperationWithNaN: if NaN it will always be forced to 0
      middleEnd = (middleStart + (middleMatch?.length ?? 0)) || 0
    } = str.match(/\]\(/) ?? EMPTY_OBJECT
    const {
      0: endmatch,
      index: endStart = NaN,
      // deepcode ignore ArithmeticOperationWithNaN: if NaN it will always be forced to 0
      end = (endStart + (endmatch?.length ?? 0)) || 0
    } = str.match(/\(\d+\)/) ?? EMPTY_OBJECT
    if (start < 0 || Number.isNaN(middleStart || middleEnd) || Number.isNaN(end)) {
      return output
    }
    // add text between last mention and this mention
    output.push(str.slice(0, start))
    // add match data
    output.push({
      name: str.slice(start + 2, middleStart),
      id: str.slice(middleEnd, end).replace(/\(|\)+/g, ''),
      index: start,
    })
    index += end
  }
  if (index < text.length - 1) {
    output.push(text.slice(index))
  }
  return output
}

export const parseCommentText = description => (
  description.split(MENTION_PATTERNS.SPLIT).map(str => (
    str.match(MENTION_PATTERNS.MATCH)
      ? str.replace(MENTION_PATTERNS.REPLACE, '')
      : str
  )).join('')
)
